import { CONTACT, BRAND_NAME } from "./contactInfo";

export const SITE_URL = CONTACT.website;
export const SITE_NAME = BRAND_NAME;

export const PRIMARY_KEYWORDS = [
  "Chenda Melam Chennai",
  "Kerala Style Traditional Chenda Melam",
  "Kerala Chenda Melam Specialists",
  "Kerala Chenda Melam",
  "Wedding Chenda Melam Chennai",
  "Traditional Kerala Melam Specialists",
  "Chenda Melam for Wedding Tamil Nadu",
  "Chenda Melam for Wedding Andhra Pradesh",
  "Chenda Melam for Wedding Telangana",
  "Book Chenda Melam",
  "Traditional Kerala Melam",
  "Chenda Melam for Wedding",
  "Professional Chenda Melam Team",
  "Chenda Melam Classes Chennai",
  "Online Chenda Melam Class",
  "Online Chenda Melam Classes Global",
  "Learn Chenda Melam Online",
  BRAND_NAME,
];

export const CHENNAI_AREAS = [
  "Anna Nagar", "Velachery", "Tambaram", "Porur", "OMR", "ECR",
  "T Nagar", "Adyar", "Chromepet", "Avadi", "Ambattur", "Medavakkam",
  "Pallikaranai", "Perungudi", "Sholinganallur",
];

export const TAMIL_NADU_CITIES = [
  "Chennai", "Coimbatore", "Madurai", "Trichy", "Salem", "Erode",
  "Tirunelveli", "Vellore", "Thanjavur", "Kanchipuram", "Hosur", "Nagercoil",
];

export const ANDHRA_PRADESH_CITIES = [
  "Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Tirupati",
  "Kakinada", "Rajahmundry", "Kurnool", "Anantapur", "Kadapa",
];

export const TELANGANA_CITIES = [
  "Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam",
  "Ramagundam", "Mahbubnagar", "Nalgonda", "Adilabad", "Siddipet",
];

export const GLOBAL_ONLINE_REGIONS = [
  "United States", "United Kingdom", "UAE", "Dubai", "Singapore",
  "Malaysia", "Canada", "Australia", "Germany", "Saudi Arabia", "Qatar", "Europe",
];

export const WEDDING_OCCASIONS = [
  { title: "Wedding Entry Chenda Melam", desc: "Grand traditional entrance for your marriage ceremony and muhurtham." },
  { title: "Groom Entry Chenda Melam", desc: "Powerful Kerala melam to welcome the groom — baraat-style procession." },
  { title: "Bride Entry Chenda Melam", desc: "Elegant traditional Chenda ensemble for the bride's ceremonial entry." },
  { title: "Baraat Chenda Melam", desc: "Energetic live percussion for wedding baraat and procession routes." },
  { title: "Reception Chenda Melam", desc: "Premium Kerala Chenda Melam for wedding receptions and evening celebrations." },
  { title: "Housewarming Chenda Melam", desc: "Auspicious Chenda Melam for griha pravesh and new home events." },
  { title: "Temple Festival Chenda Melam", desc: "Authentic Panchari Melam and temple melam for utsavams across Tamil Nadu." },
  { title: "Corporate & Inauguration", desc: "Professional Kerala traditional music for launches and cultural evenings." },
];

export const SEO_FAQ = [
  {
    q: "How to book Chenda Melam in Chennai?",
    a: `Contact ${SITE_NAME} via WhatsApp at ${CONTACT.phonesDisplay} or email ${CONTACT.email}. Share your wedding date, venue area in Chennai, and event type for a custom quote.`,
  },
  {
    q: "What is the Chenda Melam price in Chennai?",
    a: "Chenda Melam cost depends on team size, duration, and location. We offer affordable to premium packages for weddings across Chennai — contact us for transparent pricing.",
  },
  {
    q: "Do you provide Chenda Melam near me in Chennai?",
    a: "Yes. Our professional Chenda Melam team serves all major Chennai areas including OMR, ECR, Anna Nagar, Velachery, Tambaram, Adyar, T Nagar, and surrounding Tamil Nadu cities.",
  },
  {
    q: "Are Chenda Melam classes available online and offline in Chennai?",
    a: `Yes. ${SITE_NAME} offers Chenda Melam classes online and offline for Chennai students, covering Panchari Melam, Pandi Melam, and classical forms under expert gurus.`,
  },
  {
    q: "What Kerala melam forms do you perform at weddings?",
    a: "We perform Panchari Melam, Pandi Melam, Chempada Melam, Panchavadyam, and compact wedding-entry ensembles tailored for marriage functions and muhurtham.",
  },
  {
    q: "Do you provide Chenda Melam for wedding in Tamil Nadu?",
    a: "Yes. We book wedding Chenda Melam across Tamil Nadu — Chennai, Coimbatore, Madurai, Trichy, Salem, and all major cities. Contact us with your venue and date for a quote.",
  },
  {
    q: "Can I book Chenda Melam for wedding in Andhra Pradesh or Telangana?",
    a: "Yes. Our Kerala Chenda Melam team travels to Andhra Pradesh (Vijayawada, Visakhapatnam, Tirupati) and Telangana (Hyderabad, Warangal) for weddings, receptions, and cultural events.",
  },
  {
    q: "Are online Chenda Melam classes available globally?",
    a: `Yes. ${SITE_NAME} offers online Chenda Melam classes worldwide — live sessions via video call for students in the USA, UK, UAE, Singapore, Malaysia, Europe, and anywhere with internet access.`,
  },
  {
    q: "How do global online Chenda Melam classes work?",
    a: "Students join scheduled live classes, receive practice recordings, and get personalised feedback on stick technique, talam, and melam patterns. Flexible time zones for international learners.",
  },
];

export const PAGE_SEO = {
  home: {
    title: `Chenda Melam in Chennai | ${SITE_NAME}`,
    description:
      `Book Chenda Melam in Chennai for weddings, temples & events. Kerala style traditional Melam specialists — Tamil Nadu, AP & Telangana. Call/WhatsApp ${CONTACT.phonesDisplay}.`,
    path: "/",
  },
  wedding: {
    title: "Chenda Melam for Wedding in Chennai | Kerala Melam Booking",
    description:
      "Book Chenda Melam for wedding in Chennai — groom entry, baraat, reception & muhurtham. Kerala Melam team for Tamil Nadu, Andhra Pradesh & Telangana.",
    path: "/chenda-melam-chennai",
  },
  classes: {
    title: "Chenda Melam Classes in Chennai | Online & Offline Training",
    description:
      "Chenda Melam classes in Chennai — online worldwide and offline with specialist gurus. Learn Panchari Melam, Pandi Melam and classical forms.",
    path: "/chenda-classes-chennai",
  },
  courses: {
    title: "Chenda Melam Courses in Chennai | Kerala Percussion Training",
    description:
      "Chenda Melam courses in Chennai — beginner to advanced Chenda, Thimila and Idakka training under master gurus.",
    path: "/courses",
  },
  melams: {
    title: "Chenda Melam Forms in Chennai | Panchari Melam Guide",
    description:
      "Explore Chenda Melam forms in Chennai — Panchari, Pandi, Chempada, Adantha & Dhruvam for weddings and temple festivals.",
    path: "/melams",
  },
  programs: {
    title: "Chenda Melam Programs in Chennai | Weddings & Events",
    description:
      "Chenda Melam programs in Chennai for weddings, temple festivals, corporate events and cultural shows across South India.",
    path: "/programs",
  },
  fusions: {
    title: "Chenda Melam Fusion in Chennai | Instrument Collaborations",
    description:
      "Chenda Melam fusion in Chennai — Kerala Melam with Mridangam, Parai, Kanjira and folk drums for weddings, stages and cultural collaborations.",
    path: "/fusions",
  },
  contact: {
    title: "Book Chenda Melam in Chennai | Contact & WhatsApp",
    description:
      `Book Chenda Melam in Chennai — call or WhatsApp ${CONTACT.phonesDisplay}. Kerala wedding Melam across Chennai and South India.`,
    path: "/contact",
  },
  gallery: {
    title: "Chenda Melam Gallery in Chennai | Wedding & Temple Photos",
    description: `Chenda Melam gallery in Chennai — wedding, temple and cultural performance photos by ${SITE_NAME}.`,
    path: "/gallery",
  },
  testimonials: {
    title: "Chenda Melam Reviews in Chennai | Client Testimonials",
    description: `Chenda Melam reviews in Chennai — wedding and event testimonials from families and planners. ${SITE_NAME}.`,
    path: "/testimonials",
  },
  instruments: {
    title: "Instruments for Chenda Melam in Chennai | Kerala Percussion",
    description:
      "Instruments for Chenda Melam in Chennai — Chenda, Maddalam, Idakka, Thimila and Kurumkuzhal used in Melam and Panchavadyam.",
    path: "/instruments",
  },
};

export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "MusicGroup",
  name: SITE_NAME,
  description:
    "Kerala style traditional Chenda Melam specialists for weddings in Chennai, Tamil Nadu, Andhra Pradesh, and Telangana. Online Chenda Melam classes globally. Panchari Melam, Panchavadyam.",
  url: SITE_URL,
  telephone: [CONTACT.phoneTel, CONTACT.phone2Tel],
  email: CONTACT.email,
  image: `${SITE_URL}/thiruvam_logo.png`,
  logo: `${SITE_URL}/thiruvam_logo.png`,
  priceRange: "$$",
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "09:00",
    closes: "21:00",
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: CONTACT.address.line1,
    addressLocality: CONTACT.address.city,
    addressRegion: "Tamil Nadu",
    postalCode: CONTACT.address.postalCode,
    addressCountry: "IN",
  },
  areaServed: [
    { "@type": "City", name: "Chennai" },
    { "@type": "State", name: "Tamil Nadu" },
    { "@type": "State", name: "Andhra Pradesh" },
    { "@type": "State", name: "Telangana" },
    { "@type": "Country", name: "India" },
  ],
  sameAs: [CONTACT.instagram, CONTACT.facebook],
  knowsAbout: [
    "Kerala Style Traditional Chenda Melam", "Chenda Melam Specialists",
    "Chenda Melam", "Kerala Chenda Melam", "Wedding Chenda Melam",
    "Online Chenda Melam Class", "Panchari Melam", "Panchavadyam",
    "Kerala Chenda Melam for wedding", "Chenda Melam Tamil Nadu",
    "Chenda Melam Andhra Pradesh", "Chenda Melam Telangana",
  ],
});

export const getFaqSchema = (faqs = SEO_FAQ) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
});

export const getContactPageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: `Book Chenda Melam — Contact ${SITE_NAME}`,
  url: `${SITE_URL}/contact`,
  description: "Contact and book Chenda Melam for weddings, temple programs, and classes in Chennai and South India.",
});

export const getReviewSchema = (reviews) => {
  const ratings = reviews.map((r) => r.rating);
  const avg = ratings.reduce((a, b) => a + b, 0) / ratings.length;
  return {
    "@context": "https://schema.org",
    "@type": "MusicGroup",
    name: SITE_NAME,
    url: SITE_URL,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: avg.toFixed(1),
      reviewCount: reviews.length,
      bestRating: "5",
      worstRating: "1",
    },
    review: reviews.slice(0, 10).map((r) => ({
      "@type": "Review",
      author: { "@type": "Person", name: r.name },
      reviewRating: {
        "@type": "Rating",
        ratingValue: String(r.rating),
        bestRating: "5",
      },
      reviewBody: r.text,
    })),
  };
};
